import { GET_ADMINUSER, GET_ADDADMINUSER, GET_UPDATEADMINUSER} from "resources/actionTypes";

export function fetchAdminUser(data) {
    return {
      type:GET_ADMINUSER.GET_ADMINUSER_REQUESTED,payload: data,
    };
}

export function postAddadminUser(userAddAdminUser) {
  const data ={
    userAddAdminUser:userAddAdminUser,
  }
  return {
    type: GET_ADDADMINUSER.GET_ADDADMINUSER_REQUESTED,
    payload: data,
  };
}

export function patchUpdateAdminUser(userUpdateAdminUser) {
  const data ={
    userUpdateAdminUser:userUpdateAdminUser,
  }
  return {
    type: GET_UPDATEADMINUSER.GET_UPDATEADMINUSER_REQUESTED,
    payload: data,
  };
}